import { withImageOptimizationQuery } from '@common/utils';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useCoaProvidedBannerService = () => {
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);
  return {
    coa_provided_banner_image_url:
      withImageOptimizationQuery(product.coa_provided_banner_image_url, { format: 'webp', quality: 80 }) ??
      product.coa_provided_banner_image_url,
  };
};
